import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useBusyStore = defineStore('busy', () => {
  const pending = ref(0);
  const isBusy = computed(() => pending.value > 0);

  function start() {
    pending.value += 1;
  }

  function stop() {
    pending.value = Math.max(0, pending.value - 1);
  }

  async function run<T>(task: () => Promise<T>): Promise<T> {
    start();
    try {
      return await task();
    } finally {
      stop();
    }
  }

  return { pending, isBusy, start, stop, run };
});
